import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EMRService } from '../EMR.service';
import { FindingTemplateModel, FindingTemplatedataModel } from '../EMRModels/Findingtemplate.model';
import { Observable, Subject, of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExaminationHelpComponent } from '../ExaminationHelp/ExaminationHelp.component';
import { MatSort } from '@angular/material/sort';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-TemplateFindings',
  templateUrl: './TemplateFindings.component.html',
  styleUrls: ['./TemplateFindings.component.scss']
})
export class TemplateFindingsComponent implements OnInit {
  destroymedicinet$: Subject<boolean> = new Subject<boolean>();
  private findingTemplateArray: FindingTemplateModel[] = [];
  private findingTemplateobj: FindingTemplateModel = {};
  private findingTemplatedataArray: FindingTemplatedataModel[] = [];
  private templatesearch: any;
  private DoctorCtrl1: FormControl;
  private filteredDoctorArray1: Observable<any[]>;
  private doctorholdData: Observable<any[]>;
  private enabledisablebtn: boolean = true;
  // isAllowBlank: boolean = false;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  constructor(private dialog: MatDialog, private emrService: EMRService, private dashboardService: DashboardService, private authService: AuthService, private opdvisitService: OpdVisitService,
    private dialogRef: MatDialogRef<TemplateFindingsComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any) { }

  ngOnInit() {
    this.findingTemplateArray = [];
    this.findingTemplatedataArray = [];
    this.findingTemplateobj = {}
    this.gettemplateData(0, 0);
    this.getDoctorBrach();
    this.doctorControll1();

  }
  ngOnDestroy(): void {
    this.destroymedicinet$.next(true);
    this.destroymedicinet$.unsubscribe();
    this.findingTemplateArray = null;
    this.findingTemplatedataArray = null;
    this.findingTemplateobj = null;
    this.DoctorCtrl1 = null;
    this.filteredDoctorArray1 = null;
  }
  closedialog() {
    this.dialog.closeAll();
  }

  //get doctor
  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroymedicinet$)).
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);
      this.doctorControll1();
    }
    else {
      this.opdvisitService.doctors = data;
      this.doctorControll1();
    }


  }
  failed_doctors(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //New TemplateModal 
  newTemplate() {

    this.findingTemplateobj = {};
    document.getElementById("newTemplateModal").style.display = "block";
    this.doctorControll1();
    setTimeout(() => {
      if (this.authService.Loggeduser.usertypeid == 6) {
        this.findingTemplateobj.doctorName = this.authService.Loggeduser.firstname;
        this.findingTemplateobj.fK_DoctorId = this.authService.Loggeduser.userid;
      }else if(this.authService.Loggeduser.usertypeid == 9){
       this.findingTemplateobj.doctorName = this.authService.Loggeduser.firstname;
        this.findingTemplateobj.fK_DoctorId = this.authService.Loggeduser.userid;
      }
    }, 500);


  }
  CancelnewTemplate() {
    document.getElementById("newTemplateModal").style.display = "none";
    this.gettemplateData(0, this.findingTemplateobj.pK_TemplateId ? this.findingTemplateobj.pK_TemplateId : 0);
  }

  // get template data 
  rowClickedtemplate: number = -1;
  gettemplateData(tid, saveid) {
    this.getdeletetemplateExamintion = [];
    this.emrService.GetNormalFindingTemplateM(tid).pipe(takeUntil(this.destroymedicinet$)).subscribe((x: any) => {
      this.findingTemplateArray = [];
      if (x.length > 0) {
        if (this.authService.Loggeduser.usertypeid == 6) {
          this.findingTemplateArray = x.filter(item => item.fK_DoctorId == this.authService.Loggeduser.userid);
        } else {
          this.findingTemplateArray = x;
        }

        if (saveid > 0) {
          this.rowClickedtemplate = saveid;
          this.gettemplateDatabyID(saveid);
          let findobj = this.findingTemplateArray.filter(item => item.pK_TemplateId == saveid);
          this.findingTemplateobj = findobj[0];
        } else {
          this.findingTemplateobj = {};
          this.rowClickedtemplate = this.findingTemplateArray[0].pK_TemplateId;
          this.gettemplateDatabyID(this.findingTemplateArray[0].pK_TemplateId);
          this.findingTemplateobj = this.findingTemplateArray[0];
        }

      }
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  specificFinding(row) {
    this.findingTemplateobj = {};
    this.findingTemplateobj = row;
    this.rowClickedtemplate = row.pK_TemplateId;
    this.gettemplateDatabyID(row.pK_TemplateId);
  }
  gettemplateDatabyID(tid) {
    this.emrService.GetNormalFindingTemplate(tid).pipe(takeUntil(this.destroymedicinet$)).subscribe((x: any) => {
      this.findingTemplatedataArray = [];
      if (x.length > 0) {
        this.findingTemplatedataArray = x;
        this.findingTemplatedataArray.map(item => item.isEdit = true);
        this.findingTemplatedataArray.map(item => item.isDelete = false);
      }
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  editTemplate(row) {
    this.findingTemplateobj = {};
    document.getElementById("newTemplateModal").style.display = "block";
    setTimeout(() => {
      this.findingTemplateobj = row;
    }, 500)


  }
  doctorControll1() {
    this.doctorholdData = of(this.opdvisitService.doctors);
    this.DoctorCtrl1 = new FormControl();
    this.filteredDoctorArray1 = this.DoctorCtrl1.valueChanges
      .pipe(startWith(''),
        switchMap(value => this._filter(value))
      );


  }
  private _filter(value: string): Observable<string[]> {
    const searchvalue = value.toString().toLowerCase()
    return this.doctorholdData.pipe(
      map(options => options.filter(option => option.userName.toLowerCase().includes(searchvalue)))
    )
  }
  getdoctorobj1(e: any) {
    var val = e.option.value;
    this.findingTemplateobj.doctorName = val.userName;
    this.findingTemplateobj.fK_DoctorId = val.userId;

  }
  checkdocid(event: any) {
    if (event.target.value == "") {
      this.findingTemplateobj.doctorName = null;
      this.findingTemplateobj.fK_DoctorId = null;
    }
  }

  insertupdatetemplate() {
    if (this.findingTemplateobj.templateName != null && this.findingTemplateobj.templateName != "" && this.findingTemplateobj.templateName != undefined && this.findingTemplateobj.fK_DoctorId > 0 && this.findingTemplateobj.fK_DoctorId != undefined) {
      let payload = {
        "NormalFindingTemplateMaster": {
          "PK_TemplateId": this.findingTemplateobj.pK_TemplateId ? this.findingTemplateobj.pK_TemplateId : 0,
          "TemplateName": this.findingTemplateobj.templateName,
          "FK_DoctorId": this.findingTemplateobj.fK_DoctorId,
          "isActive": this.findingTemplateobj.isActive ? this.findingTemplateobj.isActive : false,
          "PK_SynchId": this.findingTemplateobj.pK_SynchId,
          "isEdit": this.findingTemplateobj.pK_TemplateId > 0 ? true : false,
          "isDelete": false
        },
        "NormalFindingTemplateDetail": []
      }
      this.emrService.InsertNormalFindingTemplate(payload).pipe(takeUntil(this.destroymedicinet$)).subscribe(item => {

        this.gettemplateData(0, item['id']);
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");


      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else {
      this.dashboardService.openSnackBar("Both field are Required", "OK");
    }

  }
  insertupdatedetailtemplate() {
  const names = this.findingTemplatedataArray.map(item => item.findingName?.trim()?.toLowerCase());
   const hasDuplicate = names.some((name, index) => names.indexOf(name) !== index);

  if (hasDuplicate) {
    this.dashboardService.openSnackBar("This record is already exists", "OK");
    return;
  }
    let payload = {
      "NormalFindingTemplateMaster": {
        "PK_TemplateId": this.findingTemplateobj.pK_TemplateId ? this.findingTemplateobj.pK_TemplateId : 0,
        "TemplateName": this.findingTemplateobj.templateName,
        "FK_DoctorId": this.findingTemplateobj.fK_DoctorId,
        "isActive": this.findingTemplateobj.isActive,
        "PK_SynchId": this.findingTemplateobj.pK_SynchId,
        "isEdit": this.findingTemplateobj.pK_TemplateId > 0 ? true : false,
        "isDelete": false
      },
      "NormalFindingTemplateDetail": this.findingTemplatedataArray.concat(this.getdeletetemplateExamintion)
    }
    this.emrService.InsertNormalFindingTemplate(payload).pipe(takeUntil(this.destroymedicinet$)).subscribe(item => {
      this.getdeletetemplateExamintion = [];
      this.enabledisablebtn = true;
      this.gettemplateData(0, this.findingTemplateobj.pK_TemplateId ? this.findingTemplateobj.pK_TemplateId : 0);
      this.dashboardService.openSnackBar("Record Saved Successfully", "OK");


    }, err => {
      this.enabledisablebtn = false;
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })

  }

  openexamination(): void {
    if (this.emrService.findingPermission.isAddPermission == true) {
      const dialogRef = this.dialog.open(ExaminationHelpComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '90vw',
        width: '90%',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.length > 0) {
          this.enabledisablebtn = false;
          result?.forEach(item => {
            this.findingTemplatedataArray.push({
              pK_TranId: 0,
              fK_NFTemplateId: this.findingTemplateobj.pK_TemplateId,
              fK_FindingId: item.fk_FindingId,
              pK_SynchId: item.pk_SynchId,
              findingName: item.findingName,
              result1: item.examValues1,
              result2: item.examValues2,
              isAllowBlank:false,
              isDelete: false,
              isEdit: false
            });
          });
          this.findingTemplatedataArray = this.findingTemplatedataArray.reduce((unique, o) => {
            if (!unique.some(obj => obj.findingName === o.findingName && obj.fK_FindingId === o.fK_FindingId)) {
              unique.push(o);
            }
            return unique;
          }, []);
        }
      });

    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  getdeletetemplateExamintion: FindingTemplatedataModel[] = [];
  removeExam(row, index: number) {
    this.enabledisablebtn = false;
    this.findingTemplatedataArray.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.getdeletetemplateExamintion.push(row);
      this.getdeletetemplateExamintion.map(item => item.isEdit = true);
      this.getdeletetemplateExamintion.map(item => item.isDelete = true);
    }

  }
  onleftchange(e: any, index: number, idcheck) {
    this.enabledisablebtn = false;
    if (e != null) {
      this.findingTemplatedataArray[index].result2 = e;
      this.findingTemplatedataArray[index].isEdit = idcheck > 0 ? true : false;
      this.findingTemplatedataArray[index].isDelete = false;
    }
  }

  isllowchnage(event:MatCheckboxChange,index,idcheck){
     this.enabledisablebtn = false;
     this.findingTemplatedataArray[index].isAllowBlank = event.checked;
     this.findingTemplatedataArray[index].isEdit = idcheck > 0 ? true : false;
  }

  onrightchange(e: any, index: number, idcheck) {
    this.enabledisablebtn = false;
    if (e != null) {
      this.findingTemplatedataArray[index].result1 = e;
      this.findingTemplatedataArray[index].isEdit = idcheck > 0 ? true : false;
      this.findingTemplatedataArray[index].isDelete = false;
    }
  }
  transferFIndingdata(arraydata: any) {
    if(!this.findingTemplateobj.isActive){
      this.dashboardService.openSnackBar("You cannot transfer inactive template", "OK");
      return
    }

  //   const filteredData = arraydata.filter(item => {
  //   return (item.result1 && item.result1.trim() !== '') || (item.result2 && item.result2.trim() !== '');
  // });

    this.dialogRef.close(arraydata);
  }

  sortdata() {

    const sortdata = this.findingTemplateArray.sort(this.compareValues('templateName'));
    this.findingTemplateobj = sortdata[0];
    this.rowClickedtemplate = sortdata[0].pK_TemplateId;
    this.gettemplateDatabyID(sortdata[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdata);

  }
  sortdatadesc() {
    const sortdataa = this.findingTemplateArray.sort(this.compareValues('templateName', 'desc'));
    this.findingTemplateobj = sortdataa[0];
    this.rowClickedtemplate = sortdataa[0].pK_TemplateId;
    this.gettemplateDatabyID(sortdataa[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdataa);
  }

  sortdatadr() {

    const sortdata = this.findingTemplateArray.sort(this.compareValues('doctorName'));
    this.findingTemplateobj = sortdata[0];
    this.rowClickedtemplate = sortdata[0].pK_TemplateId;
    this.gettemplateDatabyID(sortdata[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdata);

  }
  sortdatadescdr() {
    const sortdataa = this.findingTemplateArray.sort(this.compareValues('doctorName', 'desc'));
    this.findingTemplateobj = sortdataa[0];
    this.rowClickedtemplate = sortdataa[0].pK_TemplateId;
    this.gettemplateDatabyID(sortdataa[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdataa);
  }
  compareValues(key, order = 'asc') {

    //console.log("method called");
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }


}
